/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import CustomToolBar from "../../../ToolBar/customToolbar"
import { confirmation, followUpStatusTypes } from "../../../types/dropDownTypes"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  prevForm,
  nextForm,
} from "../../../utils/utils"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { INTERVIEW_SECTIONS } from "../../../types/interviewTypes"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"

const FollowUp = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadPrev,
    handleLoadNext,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    administrativeInterview,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useState(UserContext)

  const [followUp, setFollowUp] = useState(
    interview[INTERVIEW_SECTIONS.FOLLOW_UP]
  )
  const [validationErrors, setValidationErrors] = useState({})
  const [mixedQuestions, setMixedQuestions] = useState([])

  const toast = useRef(null)

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) =>
            q.section === INTERVIEW_SECTIONS.FOLLOW_UP &&
            !q.field.endsWith("section")
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.FOLLOW_UP
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const saveData = (setNextForm, previousForm, setNavigationItem) => {
    updateInterviewValues(INTERVIEW_SECTIONS.FOLLOW_UP, followUp)
    if (previousForm) {
      handleLoadPrev(true)
      setNextForm(prevForm(sections, activeIndex, administrativeInterview))
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_FOLLOWUP_DATA, {
          GpraI1: followUp?.gpra_i_1,
          GpraI2: followUp?.gpra_i_2,
          GpraI2a: followUp?.gpra_i_2a,
          GpraI3: followUp?.gpra_i_3,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraIId: followUp?.gpra_i_id,
          Additional: getAdditionalQuestions(followUp),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              updateInterviewValues(INTERVIEW_SECTIONS.FOLLOW_UP, {
                ...followUp,
                gpra_i_id: response.data.gpraIId,
              })
              handleLoadNext(false)
              setNextForm(
                nextForm(sections, activeIndex, administrativeInterview)
              )
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ followUp: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validForm = () => {
    const errors = {}
    if (
      followUp?.gpra_i_1 === undefined &&
      showQuestion(questions, "gpra_i_1")
    ) {
      errors.gpra_i_1 = errorMessages.requiredMessage
    }
    if (!followUp?.gpra_i_2 && showQuestion(questions, "gpra_i_2")) {
      errors.gpra_i_2 = errorMessages.requiredMessage
    } else if (
      followUp?.gpra_i_2 === 32 &&
      !followUp?.gpra_i_2a &&
      showQuestion(questions, "gpra_i_2")
    ) {
      errors.gpra_i_2a = errorMessages.requiredMessage
    }
    if (
      followUp?.gpra_i_3 === undefined &&
      showQuestion(questions, "gpra_i_3")
    ) {
      errors.gpra_i_3 = errorMessages.requiredMessage
    }
    setValidationErrors(
      validateQuestions(
        followUp,
        INTERVIEW_SECTIONS.FOLLOW_UP,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  const renderDefaultMain = (question) => {
    if (question.field === "gpra_i_1") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. Was the client able to be contacted for follow-up?`}
            required
          />
          <Dropdown
            value={followUp?.gpra_i_1}
            onChange={(e) => {
              updateState(
                "gpra_i_1",
                e.value,
                null,
                null,
                followUp,
                setFollowUp,
                null
              )
              removeError("gpra_i_1")
            }}
            options={confirmation}
            optionLabel="label"
            optionValue="value"
            className={
              validationErrors.gpra_i_1
                ? gpraStyles.input3Error
                : gpraStyles.input3
            }
            disabled={disabled}
            showClear={followUp?.gpra_i_1}
          />
          <FormError error={validationErrors.gpra_i_1} errorType={2} />
        </div>
      )
    }
    if (question.field === "gpra_i_2") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. What is the follow-up status of the client? [THIS IS A REQUIRED FIELD: NA, REFUSED, DON’T KNOW, AND MISSING WILL NOT BE ACCEPTED.]`}
              required
            />
            <Dropdown
              value={followUp?.gpra_i_2}
              onChange={(e) => {
                removeError("gpra_i_2")
                updateState(
                  "gpra_i_2",
                  e.value,
                  null,
                  null,
                  followUp,
                  setFollowUp,
                  [{ key: "gpra_i_2a", value: "" }]
                )
              }}
              options={followUpStatusTypes}
              optionLabel="label"
              optionValue="value"
              className={
                validationErrors.gpra_i_2
                  ? gpraStyles.input6Error
                  : gpraStyles.input6
              }
              disabled={disabled}
              showClear={followUp?.gpra_i_2}
            />
            <FormError error={validationErrors.gpra_i_2} errorType={2} />
          </div>
          {followUp?.gpra_i_2 === 32 && (
            <div className={gpraStyles.formRow}>
              <InputText
                disabled={followUp?.gpra_i_2 !== 32 || disabled}
                placeholder={followUp?.gpra_i_2 !== 32 ? "Not Applicable" : ""}
                value={followUp?.gpra_i_2a}
                onChange={(e) => {
                  updateState(
                    "gpra_i_2a",
                    e.target.value,
                    null,
                    null,
                    followUp,
                    setFollowUp,
                    null
                  )
                  removeError("gpra_i_2a")
                }}
                className={
                  validationErrors.gpra_i_2a
                    ? gpraStyles.inputText6AuxError
                    : gpraStyles.inputText6Aux
                }
              />
              <FormError error={validationErrors.gpra_i_2a} errorType={2} />
            </div>
          )}
        </>
      )
    }
    if (question.field === "gpra_i_3") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. Is the client still receiving services from your program?`}
            required
          />
          <Dropdown
            value={followUp?.gpra_i_3}
            onChange={(e) => {
              updateState(
                "gpra_i_3",
                e.value,
                null,
                null,
                followUp,
                setFollowUp,
                null
              )
              removeError("gpra_i_3")
            }}
            options={confirmation}
            optionLabel="label"
            optionValue="value"
            className={
              validationErrors.gpra_i_3
                ? gpraStyles.input3Error
                : gpraStyles.input3
            }
            disabled={disabled}
            showClear={followUp?.gpra_i_3 !== undefined}
          />
          <FormError error={validationErrors.gpra_i_3} />
        </div>
      )
    }
  }
  return (
    <div>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              prevForm={true}
              saveData={saveData}
              nextForm={true}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
      <Fieldset legend="I. FOLLOW UP STATUS" style={{ marginBottom: "1rem" }}>
        <div className={gpraStyles.grid}>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={
                "[REPORTED BY PROGRAM STAFF ABOUT CLIENT ONLY AT FOLLOW-UP.]"
              }
            />
          </div>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={followUp}
                    setEntity={setFollowUp}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.FOLLOW_UP}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, followUp)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={followUp}
                      setEntity={setFollowUp}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.FOLLOW_UP}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
    </div>
  )
}

FollowUp.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

FollowUp.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default FollowUp
